<div
  class="max-w-lg mx-auto bg-white rounded-xl shadow-xl p-8 mt-16 sm:mt-10 relative border border-blue-200"
>

  <h2 class="text-2xl font-extrabold mb-6 text-blue-700 text-center tracking-tight">
    Nastavitve
  </h2>
  
  <!-- Settings form starts here -->
  <form #settingsForm="ngForm" (ngSubmit)="onChangePassword()" class="space-y-6">
    <div>
      <label for="username" class="block text-sm font-semibold text-blue-700 mb-2">
        Uporabniško ime
      </label>
      <input
        id="username"
        name="username"
        type="text"
        class="w-full border border-blue-300 rounded-lg px-3 py-2 bg-blue-50 text-blue-400 cursor-not-allowed opacity-70"
        [value]="username"
        readonly
        disabled
        tabindex="-1"
        aria-disabled="true"
      />
    </div>
    <div>
      <label for="oldPassword" class="block text-sm font-semibold text-blue-700 mb-2">
        Staro geslo
      </label>
      <input
        id="oldPassword"
        name="oldPassword"
        type="password"
        class="w-full border border-blue-300 rounded-lg px-3 py-2 bg-blue-50 text-blue-900 focus:ring-2 focus:ring-blue-500"
        required
        [(ngModel)]="oldPassword"
        placeholder="Staro geslo"
      />
    </div>
    <div>
      <label for="newPassword" class="block text-sm font-semibold text-blue-700 mb-2">
        Novo geslo
      </label>
      <input
        id="newPassword"
        name="newPassword"
        type="password"
        class="w-full border border-blue-300 rounded-lg px-3 py-2 bg-blue-50 text-blue-900 focus:ring-2 focus:ring-blue-500"
        [(ngModel)]="newPassword"
        placeholder="Novo geslo"
      />
    </div>
    <div>
      <label for="newEmail" class="block text-sm font-semibold text-blue-700 mb-2">
        Nov email
      </label>
      <input
        id="newEmail"
        name="newEmail"
        type="email"
        class="w-full border border-blue-300 rounded-lg px-3 py-2 bg-blue-50 text-blue-900 focus:ring-2 focus:ring-blue-500"
        [(ngModel)]="newEmail"
        placeholder="Nov email"
      />
    </div>
    <button
      type="submit"
      class="w-full px-4 py-2 rounded-lg font-bold text-white bg-gradient-to-r from-blue-500 to-blue-700 shadow hover:from-blue-600 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500"
      [disabled]="!newPassword && !newEmail"
    >
      Shrani spremembe
    </button>
  </form>
  <!-- Settings form ends here -->

  <section class="mt-10 border-t border-blue-100 pt-8" aria-labelledby="xml-import-title">
    <div class="mb-4">
      <h3 id="xml-import-title" class="text-xl font-bold text-blue-700">Uvozi XML tarče</h3>
      <p class="mt-1 text-sm text-gray-600">Izberite eno ali več XML datotek za pripravo uvoza tarč.</p>
    </div>

    <label for="targetXmlFile" class="block cursor-pointer rounded-lg border-2 border-dashed border-blue-300 bg-blue-50 px-4 py-5 text-center text-sm font-semibold text-blue-700 transition hover:border-blue-500 hover:bg-blue-100">
      <i class="fas fa-file-code mr-2"></i>Izberi XML datoteke
    </label>
    <input
      id="targetXmlFile"
      type="file"
      multiple
      accept=".xml,text/xml,application/xml"
      class="sr-only"
      (change)="onXmlFileSelected($event)" />

    <div *ngIf="xmlFileName" class="mt-4 rounded-lg border border-blue-200 bg-white p-4 text-sm">
      <div class="flex items-center justify-between gap-3">
        <span class="font-semibold text-gray-800">{{ xmlFileNames.join(', ') }}</span>
        <button type="button" (click)="clearXmlImport()" class="shrink-0 rounded px-2 py-1 text-red-600 hover:bg-red-50" aria-label="Odstrani izbrano XML datoteko">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <p *ngIf="xmlRootName" class="mt-2 text-gray-600">Glavni element: <strong>{{ xmlRootName }}</strong></p>
      <p *ngIf="xmlStatus" class="mt-2 font-semibold text-green-700">{{ xmlStatus }}</p>
      <p *ngIf="xmlError" class="mt-2 font-semibold text-red-600">{{ xmlError }}</p>
    </div>

    <div *ngIf="savedXmlTargets.length" class="mt-5">
      <label for="savedXmlTarget" class="block text-sm font-semibold text-blue-700 mb-2">Shranjene XML tarče</label>
      <select
        id="savedXmlTarget"
        class="w-full border border-blue-300 rounded-lg px-3 py-2 bg-blue-50 text-blue-900"
        [value]="selectedSavedXmlTargetId || ''"
        (change)="selectSavedXmlTargetById($any($event.target).value)">
        <option value="" disabled>Izberite shranjeno tarčo</option>
        <option *ngFor="let target of savedXmlTargets" [value]="target.id">{{ target.display_name }} ({{ target.target_name }})</option>
      </select>
    </div>
  </section>

  <!-- Simple info modal -->
  <div *ngIf="infoOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div class="bg-white rounded-xl shadow-xl p-6 max-w-sm w-full text-center border border-blue-200">
      <h3 class="text-lg font-bold mb-2 text-blue-700">{{ infoTitle }}</h3>
      <div class="mb-4 text-blue-700">{{ infoMessage }}</div>
      <button (click)="infoOpen = false" class="px-4 py-2 rounded bg-blue-600 text-white font-bold hover:bg-blue-700">V redu</button>
    </div>
  </div>
</div>